import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import OrderTableColumnsTypeNameMap from "@/scenes/OrderManagement/map/OrderTableColumnsTypeNameMap";
import { OrderTableColumn } from "@/scenes/OrderManagement/store/OrderTableStorageStore/utils/orderTableColumns";
import { uuid } from "@/utils";
import { DownCircleOutlined, UpCircleOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import React, { useRef } from "react";
import { getOrderTablePayTimeName, getOrderTablePurchaserName } from "../../../utils";
import "./index.less";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

interface DraggableMenuItemProps {
    orderTableColumn: OrderTableColumn;

    totalLength: number;

    shop?: ShopDTO;

    /** 由于存在不在操作栏显示的Column，使用可操作的ColumnsList的index作为是否为第一个最后一个判断 */
    operableIndex: number;

    tab: OrderTab;
}

const placeElement = document.createElement("li");

placeElement.className = "draggable-menu-item-drag-place";

const innerPlaceElement = document.createElement("span");

placeElement.appendChild(innerPlaceElement);

const DraggableMenuItem: React.FC<DraggableMenuItemProps> = function (props) {
    const { orderTableColumn, totalLength, shop, tab, operableIndex } = props;

    const { type, disabled, index } = orderTableColumn || {};

    const orderManagementStore = useOrderManagementStore();

    const {
        toggleOrderTableColumnsPosition,
        dargOrderTableColumnsPosition: toggleOrderTableColumnsDrag,
    } = orderManagementStore.storage;

    const uid = useRef(uuid()).current;

    const isFirst = operableIndex === 0;

    const isLast = operableIndex === totalLength - 1;

    const element = useRef<HTMLSpanElement>();

    function getLabel() {
        if (!shop) {
            return OrderTableColumnsTypeNameMap[type];
        }

        if (type === OrderTableColumnsType.BUYER_USERNAME) return getOrderTablePurchaserName(shop.type);

        if (type === OrderTableColumnsType.PAYMENT_TIME) return getOrderTablePayTimeName(shop.type);

        if (type === OrderTableColumnsType.SHIPPING_TIME && tab === OrderTab.PRE_SHIP) {
            return "预发货时间";
        }

        return OrderTableColumnsTypeNameMap[type];
    }

    function handleDragOver(evt: React.DragEvent<HTMLSpanElement>) {
        evt.stopPropagation();
        evt.preventDefault();

        evt.dataTransfer.dropEffect = "move";

        const hoverElement = element.current;

        const hoverElementRect = hoverElement.getBoundingClientRect();

        const hoverElementClientY = evt.clientY - hoverElementRect.top;

        const hoverElementMiddleY = (hoverElementRect.bottom - hoverElementRect.top) / 2;

        const menuDom = document.getElementById("order-table-columns-menu");

        const currentMenuItemDom = document.getElementById(uid)?.closest("li");

        if (!menuDom || !currentMenuItemDom) return;

        if (hoverElementClientY < hoverElementMiddleY) {
            menuDom.insertBefore(placeElement, currentMenuItemDom);
        } else {
            menuDom.insertBefore(placeElement, currentMenuItemDom.nextElementSibling);
        }

        placeElement.setAttribute("data-target", String(index));
    }

    function handleDragStart(evt: React.DragEvent<HTMLSpanElement>) {
        evt.stopPropagation();

        evt.dataTransfer.effectAllowed = "move";

        const dragImage = document.createElement("span");

        dragImage.innerText = getLabel();

        document.body.appendChild(dragImage);
    }

    function handleDragEnd(evt) {
        evt.stopPropagation();
        if (!placeElement.parentNode) return;

        placeElement.parentNode.removeChild(placeElement);

        const target = placeElement.getAttribute("data-target");

        toggleOrderTableColumnsDrag(shop, Number(target), index);
    }

    return (
        <span ref={element} id={uid}>
            <span draggable onDragOver={handleDragOver} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                <Checkbox
                    value={type}
                    style={{ width: 105, wordBreak: "break-all", whiteSpace: "break-spaces" }}
                    disabled={disabled}
                >
                    {getLabel()}
                </Checkbox>

                <span>
                    {!isFirst && (
                        <UpCircleOutlined
                            className="mr5 fs16 em"
                            onClick={() => {
                                toggleOrderTableColumnsPosition(shop, type, true);
                            }}
                        />
                    )}

                    {!isLast && (
                        <DownCircleOutlined
                            className="fs16 em"
                            style={isFirst ? { marginLeft: 21 } : undefined}
                            onClick={() => {
                                toggleOrderTableColumnsPosition(shop, type, false);
                            }}
                        />
                    )}
                </span>
            </span>
        </span>
    );
};

export default observer(DraggableMenuItem);
